import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";
import rwn1 from "../../Images/ReverseWaterfallNaneghat/rwn1.jpg";
import rwn2 from "../../Images/ReverseWaterfallNaneghat/rwn2.jpg";
import rwn3 from "../../Images/ReverseWaterfallNaneghat/rwn3.jpg";
import rwn4 from "../../Images/ReverseWaterfallNaneghat/rwn4.jpg";
import rwn5 from "../../Images/ReverseWaterfallNaneghat/rwn5.jpg";

const data = [
  {
    day: "Day 1",
    subheading: "Reverse Waterfall + Naneghat",
    schedule: [
      { time: "05:00 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:15 AM", activity: "Pick-up at Swargate." },
      { time: "05:25 AM", activity: "Pick-up at Chhatrapati Shivaji Nagar." },
      { time: "05:45 AM", activity: "Pick-up at Nashik Phata." },
      { time: "07:30 AM", activity: "En-route breakfast.(approx)" },
      {
        time: "09:00 AM",
        activity: "Arrive at base village and trek briefing.",
      },
      {
        time: "09:30 AM",
        activity: "Begin the scenic trail towards the Reverse Waterfall.",
      },
      {
        time: "10:00 AM",
        activity:
          "Reach Reverse Waterfall and enjoy surreal views amidst magical monsoon mist.",
      },
      {
        time: "12:00 PM",
        activity: "Spend quality time at Reverse Waterfall.",
      },
      {
        time: "12:30 PM",
        activity: "Head back and trek towards Naneghat viewpoint.",
      },
      {
        time: "02:00 PM",
        activity: "Visit hidden waterfall (if time permits).",
      },
      {
        time: "03:00 PM",
        activity: "Delicious Veg & Non-Veg Lunch.",
      },
      {
        time: "04:00 PM",
        activity: "Start the return journey to Pune.",
      },
      {
        time: "07:30 PM",
        activity: "En-route evening tea.",
      },
      {
        time: "10:00 PM",
        activity: "Approx. arrival back in Pune.",
      },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "Reverse Waterfall and hidden waterfall visits are weather dependent.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg & Non-Veg Lunch",
      "☕ Evening Tea",
      "🩺 Basic First Aid & Hydration Powder",
      "🧭 Experienced Trek Lead & Guide",
      "🌿 Entry & Forest Charges",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Any personal insurance or medical expenses beyond basic first aid.",
      "Items of personal nature or additional equipment not listed.",
    ],
    verticalCards: [
      { title: "Reverse Waterfall", image: rwn2 },
      { title: "Reverse Waterfall", image: rwn1 },
      { title: "Reverse Waterfall", image: rwn3 },
      { title: "Reverse Waterfall", image: rwn4 },
      { title: "Reverse Waterfall", image: rwn5 },
    ],
    trekData: [
      {
        name: "Reverse Waterfall & Naneghat",
        image: rwn1,
        info: "Get ready for an adventurous monsoon escape to the stunning Reverse Waterfall and Naneghat! ⛰️ Located in the Junnar region near the historic Jivdhan Fort, this trek offers misty trails, lush greenery, and breathtaking Sahyadri views. Naneghat is a centuries-old mountain pass once used as a trading route and even served as an ancient toll collection point, with a rock-cut cave where inscriptions are still visible. The famous reverse waterfall appears during heavy monsoon winds. The trek is beginner-friendly to moderate, making it ideal for beginner level trekkers.",
      },
    ],
    faq: [
      {
        question: "What is a reverse waterfall?",
        answer:
          "A reverse waterfall is a unique phenomenon where the water flows upwards due to wind direction and air pressure, creating a surreal and magical sight.",
      },
      {
        question: "Is this trek suitable for beginners?",
        answer:
          "Yes. The trail is scenic and moderately easy, making it suitable for beginners with decent fitness levels.",
      },
      {
        question: "What should I carry for the trek?",
        answer:
          "Carry a small backpack, water bottle, rain gear, comfortable and sturdy trekking shoes, sunscreen, a camera, and any personal medicines. For a complete list and more detailed packing suggestions, please check our “Things to Carry” section.",
      },
      {
        question: "Are meals included?",
        answer:
          "Yes. Breakfast, morning tea, lunch, and evening tea are included in the package.",
      },
      {
        question: "Is transportation included?",
        answer:
          "Yes, Pune to Pune travel by NON-AC bus is included in the package.",
      },
      {
        question: "Will we visit the hidden waterfall?",
        answer:
          "Yes, if time permits and weather conditions are favorable, we will visit the hidden waterfall during the trek.",
      },
      {
        question: "What about the bonus surprise gift?",
        answer:
          "One lucky trekker will be selected randomly to receive a special surprise gift during the trip! 🎉",
      },
      {
        question: "Will there be a trek leader and guide?",
        answer:
          "Yes, an experienced trek lead and local guide will accompany the group throughout the trek.",
      },
    ],
  },
];

const ReverseWaterfallNaneghat = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <TrekBasicInfo
        trekName="Reverse Waterfall & Naneghat Trek"
        location="Junnar"
        trekDifficulty="Easy"
        ageLimit="16 to 36 Years"
      />
      <PackageInclusions />

      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default ReverseWaterfallNaneghat;
